module.exports = __webpack_public_path__ + "img/2.2.112ec78c.svg";